module.exports = __webpack_public_path__ + "images/icon_back_arrow_dark9bfe21b7043a40d8c1bc9422d6ab92bc.svg";